import * as React from "react"
import Layout from "../layout"
import SliceRenderer from "../slices"
import parse from "html-react-parser"
import Container from "../components/atoms/Container"
import { Helmet } from "react-helmet"
import { createGlobalStyle, css } from "styled-components"
import PrismicFooter from "../layout/PrismicFooter"

const GlobalStyles = createGlobalStyle`
  body{
    background-color: #fff;
  }
`

const PageRemoveHeaderFooter = (page) => {
  const { show_title_and_intro_text, title, intro_text, disclaimer_text } = page?.data?.prismicPage?.data

  return (
    <Layout>
      <GlobalStyles />
      <Helmet>
        <script src="/js/iframeResizer.contentWindow.min.js" type="text/javascript" />
        <base target="_blank" />
      </Helmet>
      {show_title_and_intro_text &&
        <Container removeVerticalSpacing containerProps={{
          style: {
            textAlign: "center",
            marginTop: "calc(var(--section-spacing) * 0.6667)",
            marginBottom: "calc(var(--section-spacing) / -2)"
          }
        }}>
          <h1>{title}</h1>
          {parse(intro_text?.html)}
        </Container>
      }
      <SliceRenderer doc={page?.data?.prismicPage} />

      <PrismicFooter disclaimer={parse(disclaimer_text?.html)} removeLinks={true} />
    </Layout>
  )

}

export default PageRemoveHeaderFooter
